import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { DOCTOR_REGISTRATION_FORM } from 'src/app/constant/constant';

@Component({
    selector: 'app-note-doctors',
    templateUrl: './note-doctors.component.html',
    styleUrls: [
        './note-doctors.component.css',
        '../../../../assets/css/custom-egd.css'
    ]
})
@TraceClassDecorator()
export class NoteDoctorsComponent implements OnInit {
    @Input('localSave') localSave: boolean;
    @Input('save') save: boolean;
    @Input('doctorEdit') doctorEdit: boolean;
    @Input('othermedical') othermedical: boolean;

    doctorregistration = DOCTOR_REGISTRATION_FORM;

    constructor() {}

    ngOnInit(): void {}
    openFormLink() {
        window.open(this.doctorregistration, '_blank');
    }
}
